(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const input = document.querySelector('input[name="q"]');
  if (!input) return;

  // 1. Автофокус + курсор в конец после любого релоада
  input.focus();
  if (input.value) {
    input.selectionStart = input.selectionEnd = input.value.length;
  }

  // 2. Делаем живой поиск с задержкой 400 мс и без потери фокуса
  let timer;
  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      input.form.submit();
    }, 400);
  });
});

  } catch(e) { console.error(e); }
})();
})();
